import { withVersions } from "v2/hocs/withVersions";
import CheckBoxV1 from "./CheckBox/v1";
import CheckBoxV2 from "./CheckBox/v2";

const CheckBox = withVersions({
  v1: CheckBoxV1,
  v2: CheckBoxV2,
});

export default CheckBox;
